import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ManagerExecutionService } from '../../services/manager.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { OperatorExecutionService } from 'src/app/services/operator-execution.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ActionEditDeleteBtnRendererTechnicianSubTask } from 'src/app/action-edit-delete-btn-renderer-technician-sub-task.component';
import { ExternalVendorRendererComponent } from 'src/app/external-vendor-renderer.component';
import { TechnicianRendererComponent } from 'src/app/technician-renderer.component';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
import { prevTaskService } from 'src/app/services/prev-task.service';
import { noWhitespaceValidator } from 'src/app/user-management/shared/custom-validators/form-validators';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-manager-execution-form',
  templateUrl: './manager-execution-form.component.html',
  styleUrls: ['./manager-execution-form.component.scss']
})
export class ManagerExecutionFormComponent implements OnInit {
  isEdit: boolean = false;
  @ViewChild('manageroperatorimageViewModal') private manageroperatorimageViewModal!: TemplateRef<any>;
  @ViewChild('managertechnicianimageViewModal') private managertechnicianimageViewModal!: TemplateRef<any>;
  @ViewChild('subTaskDialog') private subTaskDialog!: TemplateRef<any>;
  @ViewChild('vendorElement') vendorElement: any;

  form = new FormGroup({
    SparePartCode: new FormControl(null),
    Priority: new FormControl(null, [Validators.required]),
    assignUser: new FormControl([], [Validators.required]),
    ManagerRemarks: new FormControl(null, [Validators.required]),
    AssignTechnicianTimeStamp: new FormControl(null, [Validators.required]),
    Manageruser: new FormControl(null),
    ClosedAt: new FormControl(''),
    remark: new FormControl(''),
  });
  subTaskForm: FormGroup;
  vendorToggle: boolean = false;
  vendorMode: 'existing' | 'new' = 'existing';
  woTypeName: string = '';
  techResponded: boolean = false;
  breadcrumList!: any;
  operator: any = { LineId: '', TimeStamp: '', WOId: 0, WOStatus: '', WOType: '', FailureMode: '', SpareParts: '', Remark: '', UploadPicture: '', RequestedBy: '', MachineBreakdown: '' };
  manager: any = { SparePartCode: '', Priority: '', assignUser: [], AssignTechnicianTimeStamp: '', ManagerRemarks: '', Manageruser: '', WOId: 0, CreatedAt: new Date(), CreatedBy: 1, operExecWo: 0, MachineBreakdown: '' };
  opratorList: any;
  managerData: any;
  userList: any;
  spinnerText: string = "";
  blobStorageUrl: string = '';
  columnDefs!: any[];
  rowData: any[] | any = [];
  PriorityList: any = [];
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  OperatorFiles: any = [];
  permisson!: any;
  woType: any = [];
  failMode: any = [];
  userFiltList: any = []
  TechnicianFiles: any = [];
  isviewMode: any;
  isSelected = false;
  isSubmitting: boolean = false;
  filteredTechnicians: any;
  disableMachineBreakdown: boolean = false;
  moduleId!: any;
  pageId!: any;
  langObj: any = {};
  isAccess = ApplicationPermission.MANAGER_EXECUTION_WINDOW_ACCESS;
  isWrite = ApplicationPermission.MANAGER_EXECUTION_WINDOW_CREATE;
  isUpdate = ApplicationPermission.MANAGER_EXECUTION_WINDOW_UPDATE;
  isDelete = ApplicationPermission.MANAGER_EXECUTION_WINDOW_DELETE;
  plantSession: any;
  groupSession: any;
  vendors: any[] = [];
  vendorsList: any[] = [];
  userSession: any;
  assignTechList: any;
  meanScores: any = [];
  techListForAvgScores: any;
  AssignedTechnicianListatMaster: any = [];
  isSparePartCodeRequired: boolean;
  newUserFiltList: any = [];
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      filter: 'agSetColumnFilter',
    },
    context: {
      componentParent: this,
    },
    suppressCellSelection: true,
  };
  isSubTaskSaved: boolean = false;
  subtaskFormMode: boolean = true;
  isViewMode: boolean = false;
  frameworkComponents: any;
  technicians: any[] | any = [];
  filteredTechnicianList: any[] | any = [];
  constructor(
    public translater: TranslaterService,
    private cdr: ChangeDetectorRef,
    private RMConfigurationService: RMconfigurationService,
    private techScore: TechScoreService,
    public translate: TranslateService,
    public router: Router,
    private baseApi: BaseApi,
    private prevTaskService: prevTaskService,
    public managerExecutionService: ManagerExecutionService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public operatorExecutionService: OperatorExecutionService,
    public prevConfigurationService: PrevConfigurationService,
    private userConfigService: UserConfigurationsService,
    private dialog: MatDialog) {
    this.frameworkComponents = {
      ActionEditDeleteBtnRendererTechnicianSubTask:
        ActionEditDeleteBtnRendererTechnicianSubTask,
      ExternalVendorRendererComponent: ExternalVendorRendererComponent,
      TechnicianRendererComponent: TechnicianRendererComponent,
    };
  }

  async ngOnInit() {
    this.spinnerText = 'Loading data...';
    this.spinner.show();
    try {
      await this.getLangWords();
      this.plantSession = this.baseApi.getPlantFromStorage();
      this.groupSession = this.baseApi.getGroupFromStorage();
      this.userSession = this.baseApi.getUserSession();
      await this.getTechnicians();
      this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
      this.techListForAvgScores = this.managerExecutionService.getTechData();
      this.operator = this.managerExecutionService.getManagerData();
      this.userList = this.managerExecutionService.getUserData();
      this.assignTechList = this.managerExecutionService.getTechData();
      const woTimeStamp = new Date(this.operator.TimeStamp);
      if (woTimeStamp < new Date()) this.manager.AssignTechnicianTimeStamp = new Date();
      this.isviewMode = this.operator?.isviewButton

      const list1UserIds = this.assignTechList.map(item => item.UserId);
      const filteredList2 = this.userList.filter(item => list1UserIds.includes(item.employeeCode));
      this.userList = filteredList2;

      this.userFiltList = this.userList && this.userList.length ? this.userList.slice() : [];

      if (this.userList && this.userList.length) {
        this.userList.sort(function (a, b) {
          return parseFloat(b.AverageScore) - parseFloat(a.AverageScore);
        });
        this.userFiltList = this.userList.slice()
        this.userFiltList.sort(function (a, b) {
          return a.fullName.localeCompare(b.fullName) || b.AverageScore - a.AverageScore;
        });
      }
      else {
        this.userFiltList = []
      }
      if (!this.operator) {
        this.router.navigate(['/PM/ManagerExecutionWindow']);
        return;
      } else {
        let OperatorUploadFiles: any = [];
        let TechnicianUploadFiles: any = [];
        if (this.operator.UploadPicture) {
          OperatorUploadFiles = this.operator.UploadPicture.split(',');
          for (let i = 0; i < OperatorUploadFiles.length; i++) {
            this.OperatorFiles.push({ ImageSrc: OperatorUploadFiles[i] })
          }
        }
        if (this.operator.techExc && this.operator.techExc.AfterPicture) {
          TechnicianUploadFiles = this.operator.techExc.AfterPicture.split(',');
          for (let i = 0; i < TechnicianUploadFiles.length; i++) {
            this.TechnicianFiles.push({ ImageSrc: TechnicianUploadFiles[i] })
          }
        }
        this.operator.TimeStamp
        this.manager.operExecWo = this.operator.WOId;
        this.operator.WOType = this.operator.WOType.ID,
          this.operator.ClosedAt = this.operator.ClosedAt ? moment(this.operator.ClosedAt).format('DD/MM/YYYY hh:mm a') : '';
        this.operator.TimeStamp = moment(this.operator.TimeStamp).format('DD/MM/YYYY hh:mm a')
        this.operator.FailureMode = this.operator.FailureMode.ID;
        await this.GetAssignedTechnicianListatMaster();
        await this.GetAllTechScoreList();
        await this.getWOTypeFailureData();
        await this.findManagerData();
      }
      this.getExternalWorkColumns();
      this.subTaskForm = new FormGroup({
        Id: new FormControl(null),
        woDetails: new FormControl('', [Validators.required, noWhitespaceValidator]),
        responsible: new FormControl('', [Validators.required]),
        targetDate: new FormControl('', [Validators.required]),
        externalVendor: new FormControl(''),
        newVendorName: new FormControl(''),
        remarks: new FormControl(''),
      });
      this.subTaskForm.get('externalVendor')?.valueChanges.subscribe((value) => {
        if (value) {
          this.vendorMode = 'existing';
          this.vendorToggle = false;
        } else {
          this.vendorMode = 'new';
          this.vendorToggle = true;
        }
      });
      await this.getExternalWorkData();
      await this.getVendors();
    } catch (err) {
      console.error('Error during initialization:', err);
      this.toaster.error('An error occurred while loading data.', 'Error');
    } finally {
      this.spinner.hide();
      this.spinnerText = '';
      this.cdr.detectChanges();
    }
  }
  disablePastDates = (date: Date | null): boolean => {
    if (!date) return false;

    // Get the selected target date from the form
    const selectedDate = this.subTaskForm?.get('targetDate')?.value;

    let comparisonDate: Date;

    if (selectedDate) {
      // If a date is already selected, use it as the minimum date
      comparisonDate = new Date(selectedDate);
    } else {
      // If no date is selected, use today as the minimum date
      comparisonDate = new Date();
    }

    comparisonDate.setHours(0, 0, 0, 0); // Normalize the date

    const currentDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0); // Normalize the date being checked

    return currentDate >= comparisonDate; // Only allow dates >= comparison date
  };
  getExternalWorkColumns() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: 'ActionEditDeleteBtnRendererTechnicianSubTask',
        headerValueGetter: this.localizeHeader.bind(this),
        cellRendererParams: {
          onClickEdit: this.editRow.bind(this),
          onClickDelete: this.deleteRow.bind(this),
          onClickView: this.viewRow.bind(this),
          isUpdate: this.isUpdate, // <--- pass it
          isDelete: this.isDelete, // <--- pass it
          isTechnicianScreen: false, // <--- pass it
        },
        pinned: 'left',
        minWidth: 200,
      },
      {
        headerName: 'WO Details',
        field: 'woDetails',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Responsible',
        field: 'responsible',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'External Vendor',
        field: 'externalVendor',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Remarks',
        field: 'Remarks',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'status',
        minWidth: 200,
        cellStyle: (params) => {
          if (params.value === 'Pending') {
            return {
              backgroundColor: '#FFFF00',
              color: 'black',
              fontWeight: 'bold',
            };
          }
          else if (params.value === 'InProcess') {
            return {
              backgroundColor: '#FFA500',
              color: 'white',
              fontWeight: 'bold',
            };
          }
          else if (params.value === 'Disapproved') {
            return {
              color: 'red',
              fontWeight: 'bold',
            };
          }
          else if (params.value === 'Completed' || params.value === 'Closed') {
            return {
              backgroundColor: '#38CF36',
              color: 'white',
              fontWeight: 'bold',
            };
          }
          return null;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target Date',
        field: 'targetDate',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params: any) => params.value ? this.formatCellData(params.value, 'dateOnly') : null,
      },
      {
        headerName: 'Completion Date',
        field: 'completionDate',
        minWidth: 200,
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created By',
        field: 'IsManager',
        minWidth: 200,
        valueFormatter: (params: any) => {
          const isManager = params.value === true || params.value === 'true';
          return isManager ? 'Manager' : 'Technician';
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'UpdatedBy',
        field: 'UpdatedBy',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Updator',
        field: 'Updator',
        minWidth: 200,
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }
  searchValues(event: any, type: string) {
    const filter = event.target.value.toLowerCase();
    switch (type) {
      case 'tech':
        this.filteredTechnicianList = this.technicians.filter((tech) =>
          tech.name.toLowerCase().includes(filter)
        );
        break;
      case 'vender':
        this.vendorsList = this.vendors.filter((ven) =>
          ven.Name.toLowerCase().includes(filter)
        );
        break;
    }
  }
  async getExternalWorkData(): Promise<void> {
    if (!this.operator || !this.operator.WOId) {
      console.warn('technicianTaskId is not available');
      this.rowData = [];
      return;
    }
    try {
      const res: any[] = await lastValueFrom(this.prevTaskService
        .getSubTaskWorkOrderByTaskId(
          null,
          null,
          this.operator.WOId
        ));
      console.log('res', res);
      this.rowData = res.map((item) => ({
        id: item.Id,
        woDetails: item.Detail,
        responsible:
          this.getResponsibleName(item.ResponsibleID) ||
          item.ResponsibleName ||
          item.ResponsibleID,
        responsibleId: item.ResponsibleID,
        externalVendor: item.externalVendor || null,
        externalVendorId: item.ExternalVendorId,
        Remarks: item.SubTaskRemarks || '',
        IsManager: item.IsManager || false,
        CreatedBy: this.getResponsibleName(item.CreatedBy) || item.CreatedBy,
        UpdatedBy: this.getResponsibleName(item.UpdatedBy) || item.UpdatedBy,
        Updator: item.Updator || '',
        status: item.Status,
        targetDate: item.TargetDate
          ? item.TargetDate
          : '',
        completionDate: item.CompletionDate
          ? item.CompletionDate
          : '',
        isApproved: item.IsApproved,
        approvedBy: item.ApprovedBy,
        approvalDate: item.ApprovalDate,
      }));
      console.log('Subtasks loaded:', this.rowData);
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error fetching subtasks:', err);
      this.toaster.error('Error fetching subtasks', 'Error');
      this.rowData = [];
      this.cdr.detectChanges();
    }
  }
  onPanelClose(isOpen: boolean, type: string, inputElement: HTMLInputElement) {
    if (!isOpen) {
      inputElement.value = '';
      switch (type) {
        case 'tech':
          this.filteredTechnicianList = [...this.technicians];
          break;
        case 'vender':
          this.vendorsList = [...this.vendors];
          break;
      }
    }
  }
  submitForm(): void {
    if (this.subTaskForm.invalid) {
      console.warn('Form is invalid');
      return;
    }
    this.spinner.show();
    this.isSubmitting = true;

    const formValue = this.subTaskForm.value;

    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      WOId: this.operator.WOId,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor,
      ExternalVendorId: externalVendorId,
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'RM',
      PlantCode: this.plantSession.plantCode,
      GroupCode: this.groupSession.groupCode,
      UserCode: this.userSession.userCode,
      IsManager: true,
      Remarks: formValue.remarks || null,
    };

    console.log('Submitting payload:', payload);
    const request$ = this.prevTaskService.addSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        this.spinner.hide();
        this.toaster.success('SubTask Work Order Saved Successfully');
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        console.error('Error creating subtask:', err);
        this.spinner.hide();
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }
  updateSubtaskForm(): void {
    if (this.subTaskForm.invalid) {
      console.warn('Form is invalid');
      return;
    }
    this.spinner.show();
    this.isSubmitting = true;

    const formValue = this.subTaskForm.value;

    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      WOId: this.operator.WOId,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor,
      ExternalVendorId: externalVendorId,
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'RM',
      PlantCode: this.plantSession.plantCode,
      GroupCode: this.groupSession.groupCode,
      UserCode: this.userSession.userCode,
      IsManager: true,
      Remarks: formValue.remarks || null,
    };

    console.log('Submitting payload:', payload);
    const request$ = this.prevTaskService.updateSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        this.spinner.hide();
        console.log('Subtask Updated successfully:', response);
        if (payload.Id) {
          this.toaster.success('SubTask Work Order Updated Successfully');
        }
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        console.error('Error creating subtask:', err);
        this.spinner.hide();
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }
  async getVendors(): Promise<void> {
    const data = {
      PlantCode: this.plantSession.plantCode,
      GroupCode: this.groupSession.groupCode,
    };
    try {
      const res: any = await lastValueFrom(this.prevTaskService.getPMExternalVendor(data));
      this.vendors = res.data;
      this.vendorsList = this.vendors;
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error fetching vendors:', err);
      this.toaster.error('Error fetching vendors', 'Error');
    }
  }
  async getTechnicians(): Promise<void> {
    if (!this.plantSession.plantCode) {
      console.warn('Plant code is not available');
      this.technicians = [];
      return;
    }

    const key = {
      Plant: this.plantSession?.plantCode,
    };

    try {
      const res: any[] = await lastValueFrom(this.techScore.getAllTechScoreList(key));
      const uniqueTechnicians = Array.from(
        new Map(
          res.map((item) => [
            item.TechId || item.EmployeeCode,
            {
              id: item.TechId || item.EmployeeCode,
              name: item.full_name,
            },
          ])
        ).values()
      );

      this.technicians = uniqueTechnicians;
      this.filteredTechnicianList = this.technicians;
      console.log('Technicians loaded:', this.technicians);
    } catch (err) {
      console.error('Error fetching technicians:', err);
      this.toaster.error('Error fetching technicians', 'Error');
      this.technicians = [];
    }
  }

  getResponsibleName(responsibleId: string): string {
    const technician = this.technicians.find(
      (tech) => tech.id === responsibleId
    );
    return technician ? technician.name : '';
  }
  deleteRow(element: any): void {
    console.log('Current subTasksArray:', this.rowData);
    console.log('Element to delete:', element.rowData);
    const data = {
      Id: element.rowData.id,
      UserCode: this.userSession.userCode,
    };
    console.log('datafordelete', data);
    this.prevTaskService.deletePrevTask(data).subscribe({
      next: (res: string) => {
        console.log('Server says:', res);
        this.toaster.success('SubTask Work Order deleted successfully.');
        this.getExternalWorkData();
      },
      error: (err) => {
        console.error('Delete failed:', err);
      },
    });
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  editSubTask(element: any): void {
    this.subtaskFormMode = false;
    this.isViewMode = false;
    if (!element.externalVendorId && element.externalVendor) {
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: '',
        remarks: element.Remarks || '',
      });
    } else {
      this.vendorMode = 'existing';
      this.vendorToggle = false;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: element.externalVendorId || '',
        newVendorName: '',
        remarks: element.Remarks || '',
      });
    }

    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.cdr.detectChanges();
    });
  }
  editRow(element: any) {
    this.editSubTask(element.rowData);
  }

  viewRow(element: any): void {
    this.viewSubTask(element.rowData);
  }

  viewSubTask(element: any): void {
    this.subtaskFormMode = false;
    this.isViewMode = true;
    if (!element.externalVendorId && element.externalVendor) {
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: '',
        remarks: element.Remarks || '',
      });
    } else {
      this.vendorMode = 'existing';
      this.vendorToggle = false;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: element.externalVendorId || '',
        newVendorName: '',
        remarks: element.Remarks || '',
      });
    }

    // Disable all form fields for view mode
    this.subTaskForm.disable();

    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      // Re-enable form fields after closing
      this.subTaskForm.enable();
      this.isViewMode = false;
      this.resetForm();
      this.cdr.detectChanges();
    });
  }

  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }
  imgview() {
    let dialogRef = this.dialog.open(this.manageroperatorimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  oncloseimg() {
    this.dialog.closeAll();
  }
  imgview1() {
    let dialogRef = this.dialog.open(this.managertechnicianimageViewModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  oncloseimg1() {
    this.dialog.closeAll();
  }
  async getLangWords(): Promise<void> {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    try {
      const res: any = await lastValueFrom(this.translater.getLangWords(key));
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi?.refreshHeader();
      }
    } catch (err) {
      console.error('Error fetching language words:', err);
      this.toaster.error('Error fetching language words', 'Error');
    }
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }

  comboChange(event: any, filter: any): void {
    console.log(event);
    const filterElement: HTMLElement = document.querySelector(`#${filter}`);
    if (filterElement) {
      const inputElement: HTMLInputElement = filterElement.querySelector('input');
      if (inputElement) {
        inputElement.value = '';
        this.userFiltList = [...this.newUserFiltList];
        this.cdr.detectChanges();
      }
    }
  }
  onVendorToggleChange(event: any) {
    if (event.checked) {
      this.vendorMode = 'new';
      this.vendorElement.nativeElement.focus();
    } else {
      this.vendorMode = 'existing';
    }
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.gridApi.sizeColumnsToFit();
  }
  cellClicked(params: any): void {
  }
  openWOdialog(): void {
    this.subtaskFormMode = true;
    this.isSubTaskSaved = false;
    this.isViewMode = false;
    this.resetForm();
    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
    });

    dialogRef.afterClosed().subscribe(() => {
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.updateGridData();
      this.cdr.detectChanges();
    });
  }
  resetForm(): void {
    this.subTaskForm.reset();
    this.vendorToggle = false;
    this.vendorMode = 'existing';
    this.subTaskForm.patchValue({
      woDetails: '',
      responsible: '',
      externalVendor: '',
      newVendorName: '',
      targetDate: '',
    });
    this.subTaskForm.markAsPristine();
    this.subTaskForm.markAsUntouched();
    console.log('Form reset');
  }
  updateGridData() {
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
      this.gridApi.refreshCells({ force: true });
    }
  }
  async getWOTypeFailureData(): Promise<void> {
    const data = {
      WOType: this.operator.WOType,
      group: this.groupSession?.groupCode,
      plant: this.plantSession?.plantCode
    }
    try {
      const res: any = await lastValueFrom(this.operatorExecutionService.getOperatorMasterData(data));
      if (res.status) {
        this.woType = res.WOTypes;
        this.failMode = res.failureModes;
        this.operator.FailureMode = this.failMode[0]?.ID;
        this.operator.WOType = this.operator.WOType
        this.operator.FailureMode = this.operator.FailureMode
        this.woTypeName = this.woType.find(x => x.ID == this.operator.WOType)?.Name;
        const uniqueScores = 'uniqueScores';
        const newArray = this.userFiltList.map(obj => {
          const matchingMeanScore = this.meanScores.find(x => x.EmployeeCode == obj.employeeCode && x.WOName == this.woTypeName);
          const meanScore = matchingMeanScore ? matchingMeanScore.AvgScore : 0;

          return { ...obj, [uniqueScores]: meanScore };
        });
        const avgScores = 'avgScores';
        const newArray2 = newArray.map(obj => {
          const matchingMeanScore = this.techListForAvgScores.find(x => x.UserId == obj.employeeCode);

          const valAvg = matchingMeanScore ? matchingMeanScore.AverageScore : 0;

          return { ...obj, [avgScores]: valAvg };
        });

        const matchingEmployees = newArray2.filter(employee => this?.AssignedTechnicianListatMaster.includes(employee.employeeCode));
        this.userFiltList = matchingEmployees;
        this.newUserFiltList = this.userFiltList.slice();
      }
      else
        this.toaster.error('Error', res.message)
    } catch (err: any) {
      console.error('Error fetching WO type failure data:', err);
      this.toaster.error('Error', err.message || 'Failed to fetch master data');
    }
  }

  onsparechange(event) {
    console.log(event.target.getAttribute("aria-checked"));
  }

  async findManagerData(): Promise<void> {
    const obj = {
      UserId: this.userSession?.userCode,
      WOID: this.operator ? this.operator.WOId : '',
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode,
    }
    try {
      const res: any = await lastValueFrom(this.managerExecutionService.getOperatorData(obj));
      if (res.MEWo) {
        this.techResponded = res.MEWo.techExc ? true : false;
        this.woTypeName = res.MEWo.WOType.Name;
        this.operator.WOIdDisplay = res.MEWo.WOId;
        this.operator.MachineBreakdown = res.MEWo.MachineBreakdown;
        let techMaxScore: any;
        let techMaxAvg: any;
        let userByScoreAvg: number = 0;
        this.PriorityList = res.priority;
        for (let tech of res.technician) {
          let score = tech.TechScore.find((scr: any) => scr.WOTypeId && scr.WOTypeId.ID == res.MEWo.WOType.ID);
          if (score) {
            tech.Score = score.Score;
            score.UserId = tech.UserId;
          }
          if ((!techMaxScore && score) || (score && score.Score && techMaxScore && techMaxScore.Score && score.Score > techMaxScore.Score))
            techMaxScore = score;
        }
        let techList: any = [];
        if (res.technician && res.technician.length) {
          for (let tech of res.technician) {
            tech.Score = tech.Score ? tech.Score : 0;
            const chk = techList.find((t: any) => t == tech.UserId)
            if (!chk)
              techList.push(tech.UserId);
          }
          if (this.userList && this.userList.length) {
            this.userList = this.userList.filter((item: any) => techList.includes(item.employeeCode))
            if (this.userList && this.userList.length) {
              for (let technician of res.technician) {
                const userIndex = this.userList.findIndex((user: any) => technician.UserId == user.employeeCode);
                if (this.userList[userIndex]) {
                  this.userList[userIndex].AverageScore = technician.AverageScore ? technician.AverageScore : 0;
                  this.userList[userIndex].Score = technician.Score;
                  if (!techMaxAvg || (techMaxAvg && techMaxAvg.AverageScore && technician.AverageScore > techMaxAvg.AverageScore))
                    techMaxAvg = technician;
                }
              }
            }
            if (techMaxScore)
              userByScoreAvg = techMaxScore.UserId;
            else if (techMaxAvg)
              userByScoreAvg = techMaxAvg.UserId;
          }
        }

        this.userList.sort((a, b) => {
          const nameA = a.fullName.toUpperCase();
          const nameB = b.fullName.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        this.userList.sort((a: any, b: any) => parseFloat(b.AverageScore) - parseFloat(a.AverageScore));

        this.userList.sort((a: any, b: any) => parseFloat(b.Score) - parseFloat(a.Score));

        if (res.MEWo.managerExc) {
          this.manager = res.MEWo.managerExc;
          this.manager.Priority = res.MEWo.managerExc.Priority && res.MEWo.managerExc.Priority.ID ? res.MEWo.managerExc.Priority.ID : '';
          const selectedValues = res.MEWo.managerExc.assignUser ? res.MEWo.managerExc.assignUser.split(',').map(userId => userId) : [];
          const validSelectedValues = selectedValues.filter(value => this.userFiltList.some(user => user.employeeCode === value));
          this.form.patchValue({
            assignUser: validSelectedValues
          });
          this.isEdit = true;
        } else {
          this.isEdit = false;
          this.form.patchValue({
            assignUser: []
          });
        }
        this.manager.Manageruser = this.userSession?.fullName;
        if (this.PriorityList && this.PriorityList.length) {
          const findhigh = this.PriorityList.find((pri: any) => pri.Name.trim().toLowerCase() == 'high')
          if (findhigh && !this.manager.Priority)
            this.manager.Priority = findhigh.ID
        }
        const sparepart = this.operator.SpareParts == 'Required' ? 1 : 0;
        this.operator.SpareParts = sparepart;

        if (sparepart == 1) {
          this.form.controls["SparePartCode"].setValidators([Validators.required]);
          this.form.controls['SparePartCode'].updateValueAndValidity();
          this.form.controls['SparePartCode'].enable();
          this.isSparePartCodeRequired = true;
        }
        else {
          this.form.controls["SparePartCode"].setValidators(null);
          this.form.controls['SparePartCode'].updateValueAndValidity();
          this.form.controls['SparePartCode'].disable();
          this.isSparePartCodeRequired = false;
        }
      }
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error fetching manager data:', err);
      this.toaster.error('Error fetching manager data', 'Error');
    }
  }

  onSubmit() {
    if (!this.form.valid) {
      this.toaster.warning('Please Fill All Required Field', 'Error', {
        timeOut: 3000,
      });
      return false;
    } else {
      this.spinnerText = "Save Manager Data";
      this.spinner.show();
      const selectedUsers = this.form.get('assignUser').value.filter((a: any) => a !== '0');
      this.manager.assignUser = selectedUsers;
      this.manager.Manageruser = this.userSession?.userCode;
      this.manager.CreatedBy = this.userSession.userCode;
      this.manager.WOId = this.operator.WOId;
      this.manager.WOType = this.operator.WOType;
      this.manager.FailureMode = this.operator.FailureMode;
      this.manager.SpareParts = this.operator.SpareParts ? 1 : 0;
      this.manager.AssignTechnicianTimeStamp = this.manager.AssignTechnicianTimeStamp;
      this.manager.MachineBreakdown = this.operator.MachineBreakdown;
      if (this.isEdit) {
        this.managerExecutionService.updateManagerData(this.manager).subscribe((res: any) => {
          if (res.status)
            this.toaster.success('Success', 'Data Updated Successfully');
          this.spinner.hide();
          this.router.navigate(['/PM/ManagerExecutionWindow']);
        })
      } else {
        this.managerExecutionService.addManagerData(this.manager).subscribe((res: any) => {
          if (res.status) {
            if (res.result) {
              this.addUserWiseNotification(res.result);
            }
            this.toaster.success('Success', 'Data Inserted Successfully');
          }
          this.spinner.hide();
          this.router.navigate(['/PM/ManagerExecutionWindow']);
        })
      }
      return true;
    }
  }

  addUserWiseNotification(val: any) {
    const data = {
      userId: val.assignUser,
      desc: `Work Order ID ${val.WOId} Is Opened`,
      title: 'Work Order',
      createdBy: JSON.parse(localStorage.user).UserId,
    };
    this.spinnerText = 'Adding User Wise Notification';
    this.spinner.show();
    this.prevConfigurationService.addUserWiseNotification(data).subscribe((res: any) => {
      this.spinner.hide();
      if (res.status) {
        this.toaster.success('Success', res.message);
      }
    }, (error: any) => {
      this.spinner.hide();
      this.toaster.error('Error', error.ErrorMessage);
    });
  }

  SpareToggle(event: any) {
    if (event?.checked) {
      this.form.controls["SparePartCode"].setValidators([Validators.required]);
      this.form.controls['SparePartCode'].updateValueAndValidity();
      this.form.controls['SparePartCode'].enable();
      this.isSparePartCodeRequired = true;
    }
    else {
      this.form.controls["SparePartCode"].setValidators(null);
      this.form.controls['SparePartCode'].updateValueAndValidity();
      this.form.controls['SparePartCode'].disable();
      this.form.controls['SparePartCode'].setValue('');
      this.isSparePartCodeRequired = false;
    }
  }

  validateAssignTechnicianTimeStamp() {
    const a = new Date(this.manager.AssignTechnicianTimeStamp);
    const b = new Date(moment(this.operator.TimeStamp, "DD/MM/YYYY hh:mm a").toDate());
    if (a < b) {
      this.toaster.warning('Assign Technician Time Should Not Be Prior To WO Time Stamp', 'Warning', {
        timeOut: 3000,
      });
      this.form.patchValue({ AssignTechnicianTimeStamp: null })
      this.manager.AssignTechnicianTimeStamp = null;
      return;
    }
  }

  selectAllItems() {
    this.isSelected = !this.isSelected;
    if (this.isSelected) {
      const filteredArray = this.userFiltList?.map(item => item.employeeCode);
      this.form.patchValue({
        assignUser: filteredArray
      });
    } else {
      this.form.patchValue({
        assignUser: []
      });
    }
  }

  async GetAllTechScoreList(): Promise<void> {
    const key = {
      Plant: this.plantSession?.plantCode
    }
    try {
      const res: any = await lastValueFrom(this.techScore.getAllTechScoreList(key));
      this.meanScores = res;
      const uniqueScores = 'uniqueScores';
      const newArray = this.userFiltList.map(obj => {
        const matchingMeanScore = this.meanScores.find(x => x.EmployeeCode == obj.employeeCode && x.WOName == this.woTypeName);
        const meanScore = matchingMeanScore ? matchingMeanScore.AvgScore : 0;
        return { ...obj, [uniqueScores]: meanScore };
      });

      const avgScores = 'avgScores';
      const newArray2 = newArray.map(obj => {
        const matchingMeanScore = this.techListForAvgScores.find(x => x.UserId == obj.employeeCode);
        const valAvg = matchingMeanScore ? matchingMeanScore.AverageScore : 0;
        return { ...obj, [avgScores]: valAvg };
      });
      const matchingEmployees = newArray2.filter(employee => this?.AssignedTechnicianListatMaster.includes(employee.employeeCode));
      this.userFiltList = matchingEmployees;
      this.newUserFiltList = this.userFiltList.slice();
      this.cdr.detectChanges();
    } catch (error: any) {
      console.error('Error fetching tech scores:', error);
      this.toaster.error('Error fetching tech scores', 'Error');
    }
  }

  async GetAssignedTechnicianListatMaster(): Promise<void> {
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'RM',
    };
    try {
      const res: any = await lastValueFrom(this.RMConfigurationService.getTechnician(data));
      const assignedUserlist = res.data;
      this.AssignedTechnicianListatMaster = assignedUserlist.map(item => item.UserId)
    } catch (error: any) {
      console.error('Error fetching assigned technicians:', error);
      this.toaster.error('Error', error.message || 'Failed to fetch assigned technicians');
    }
  }
}